import { isArr } from '../../../global-utils';
import { resolveTimeBasedWrapper } from '../../../global-utils/vmFunctions/dateTime';

const randomize = (arr) => {
  if (!isArr(arr)) return arr;
  return [...arr].sort(() => Math.random() - 0.5);
};

export const filterTimeBasedComponents = (components, shouldRandomize) => {
  if (!isArr(components)) return components;

  const filtered = components?.filter((component) => {
    const { startsAt, endsAt, isDisabled } = component;

    // If it has no time window, assume it should be shown
    if (!startsAt && !endsAt) return true;
    if (isDisabled) return false;

    // Use the shared utility
    return resolveTimeBasedWrapper({ startsAt, endsAt });
  });

  return shouldRandomize ? randomize(filtered) : filtered;
};
